import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { useNavigate } from 'react-router-dom';

export default function InstrucoesPage() {
    const [instrucoes, setInstrucoes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [paroquiaNome, setParoquiaNome] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchInstrucoes = async () => {
            const userData = localStorage.getItem('user');
            if (!userData) return;

            const user = JSON.parse(userData);
            const grupoId = user?.grupo_id;
            const paroquia = user?.paroquia;

            if (!grupoId) return;

            setParoquiaNome(paroquia);

            try {
                const response = await api.get(`/instrucoes/grupo/${grupoId}`);
                setInstrucoes(response.data);
            } catch (error) {
                // erro já tratado abaixo
            } finally {
                setLoading(false);
            }
        };

        fetchInstrucoes();
    }, []);

    return (
        <div className="min-h-screen bg-gradient-to-br from-green-50 to-white flex flex-col items-center px-4 py-8">
            <div className="w-full max-w-4xl bg-white p-8 rounded-2xl shadow-2xl">
                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-8 gap-4">
                    <h1 className="text-3xl font-extrabold text-gray-800 text-center sm:text-left flex-1">
                        Instruções <span className="block text-lg font-medium text-green-700">{paroquiaNome || 'Paróquia não identificada'}</span>
                    </h1>
                    <button
                        onClick={() => navigate(-1)}
                        className="w-full sm:w-auto px-6 py-3 bg-green-600 text-white rounded-lg font-semibold shadow hover:bg-green-700 transition-colors flex items-center justify-center"
                    >
                        <span className="inline-block align-middle mr-2 text-xl" style={{ verticalAlign: 'middle', minWidth: '20px' }}>←</span>
                        Voltar para Home
                    </button>
                </div>

                {loading ? (
                    <div className="text-center text-gray-500 py-12 text-lg">Carregando instruções...</div>
                ) : instrucoes.length === 0 ? (
                    <div className="text-center text-gray-500 py-12 text-lg">Nenhuma instrução encontrada.</div>
                ) : (
                    <div className="space-y-8">
                        {instrucoes.map((instrucao) => (
                            <div
                                key={instrucao.id}
                                className="bg-green-50 border border-green-100 p-6 rounded-xl shadow hover:shadow-md transition"
                            >
                                <h2 className="text-xl font-bold text-green-800">{instrucao.titulo}</h2>
                                <p className="text-gray-700 mt-2 whitespace-pre-line">{instrucao.descricao}</p>
                                <div className="flex justify-end mt-4">
                                    <span className="text-xs text-gray-500 italic">
                                        Publicado em:{' '}
                                        {instrucao.created_at && !isNaN(new Date(instrucao.created_at))
                                            ? (() => {
                                                const dateUTC = new Date(instrucao.created_at);
                                                if (isNaN(dateUTC.getTime())) return '';
                                                const diaUTC = String(dateUTC.getUTCDate()).padStart(2, '0');
                                                const mesUTC = String(dateUTC.getUTCMonth() + 1).padStart(2, '0');
                                                const anoUTC = dateUTC.getUTCFullYear();
                                                return `${diaUTC}/${mesUTC}/${anoUTC}`;
                                            })()
                                            : 'Data não informada'}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}